export type EhrWritePath =
  | "medication"
  | "condition"
  | "vitals"
  | "lab"
  | "procedure"
  | "note"
  | "allergy"
  | "immunization";

export type EhrWriteParams = {
  patientId: string;
  resource: object;
  path: EhrWritePath;
};

export type EhrWrite = (params: EhrWriteParams) => Promise<void>;

export type EhrResourceDiffJobRequest = {
  metadata: {
    id: string;
    cxId: string;
    patientId: string;
    requestId: string;
    status: "waiting" | "processing" | "completed" | "failed";
  };
  response?: {
    preSignedUrls: string[];
    resourceTypes: string[];
  };
};

export type EhrDiff = {
  getResourceDiffJob: (
    patientId: string,
    requestId?: string
  ) => Promise<EhrResourceDiffJobRequest | undefined>;
  startResourceDiffJob: (patientId: string) => Promise<string>;
};

export type EhrDetails = {
  ehrPatientId: string;
  name: EhrName;
  write?: EhrWrite;
  diff?: EhrDiff;
};

export enum EhrName {
  Athena = "Athena",
  Canvas = "Canvas",
  Elation = "Elation",
  Healthie = "Healthie",
  EClinicalWorks = "EClinicalWorks",
}
